module.exports = __webpack_public_path__ + "677676223408fcd387f67594c5c1dc5f.pdf";